import React from 'react';
import CommissionsList from './CommissionsList';

const CommissionContent = () => {
  return <CommissionsList />;
};

export default React.memo(CommissionContent);
